// ABC SEO/GEO — Content Studio. Generate a SEO/GEO-optimized article + a
// multi-channel social campaign from an approved keyword (Claude-powered),
// then copy / download / (soon) publish to GHL Blog + Social Planner.
(function () {
  const { Icon } = window.SGIcons;
  const { Card, CardHead, PageHead } = window.SGKit;

  const PLATFORM = {
    facebook:        { label: 'Facebook',         c: '#1877F2', bg: '#E7F0FE' },
    instagram:       { label: 'Instagram',        c: '#C13584', bg: '#FBE9F3' },
    linkedin:        { label: 'LinkedIn',          c: '#0A66C2', bg: '#E6F0FA' },
    google_business: { label: 'Google Business',   c: '#0F9D58', bg: '#E6F4EC' },
    x:               { label: 'X',                 c: '#111827', bg: '#EDEFF2' },
    twitter:         { label: 'X',                 c: '#111827', bg: '#EDEFF2' },
    tiktok:          { label: 'TikTok',            c: '#111827', bg: '#EDEFF2' },
  };
  const platMeta = (p) => PLATFORM[(p || '').toLowerCase()] || { label: p || 'Post', c: 'var(--sg-text-2)', bg: 'var(--sg-sunken)' };

  const TONES = ['Professional', 'Friendly', 'Authoritative', 'Conversational', 'Bold'];

  function copy(text, key, setCopied) {
    try {
      navigator.clipboard.writeText(text).then(() => { setCopied(key); setTimeout(() => setCopied(null), 1600); });
    } catch (e) { /* clipboard blocked */ }
  }
  function download(filename, text, type) {
    try {
      const blob = new Blob([text], { type: type || 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename; document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch (e) { /* noop */ }
  }

  function CopyBtn({ text, k, copied, setCopied, label }) {
    const on = copied === k;
    return (
      <button onClick={() => copy(text, k, setCopied)}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 32, padding: '0 12px', border: '1px solid ' + (on ? 'var(--sg-green)' : 'var(--sg-border)'), borderRadius: 'var(--sg-radius-pill)', background: on ? 'var(--sg-green-50)' : 'var(--sg-card)', color: on ? 'var(--sg-green)' : 'var(--sg-text-2)', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12 }}>
        <Icon name={on ? 'check' : 'copy'} size={13} /> {on ? 'Copied' : (label || 'Copy')}
      </button>
    );
  }

  function SoonBtn({ icon, label, onClick }) {
    return (
      <button onClick={onClick}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 38, padding: '0 16px', border: '1px dashed var(--sg-border)', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-sunken)', color: 'var(--sg-text-2)', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 13 }}>
        <Icon name={icon} size={15} /> {label}
        <span style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '0.04em', color: 'var(--sg-violet-700)', background: 'var(--sg-violet-100)', padding: '2px 6px', borderRadius: 'var(--sg-radius-pill)' }}>SOON</span>
      </button>
    );
  }

  function ArticleResult({ article, engine, copied, setCopied }) {
    const fullHtml = (article.jsonLd ? '<script type="application/ld+json">' + JSON.stringify(article.jsonLd) + '<\/script>\n' : '')
      + '<h1>' + article.title + '</h1>\n' + article.bodyHtml;
    return (
      <Card>
        <CardHead title="Article" sub={'/' + article.slug}
          right={<span style={{ fontSize: 11, fontWeight: 700, color: 'var(--sg-violet-700)', background: 'var(--sg-violet-100)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>{engine === 'claude' ? '✨ Claude' : 'Workers AI'}</span>} />
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* SEO meta */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 10 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{ flex: 'none', fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', width: 70, paddingTop: 3 }}>Title</span>
              <span style={{ flex: 1, fontSize: 15, fontWeight: 700, color: 'var(--sg-text)' }}>{article.title}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{ flex: 'none', fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', width: 70, paddingTop: 2 }}>Meta</span>
              <span style={{ flex: 1, fontSize: 13, color: 'var(--sg-text-2)' }}>{article.metaDescription}</span>
            </div>
          </div>

          {/* rendered article */}
          <div style={{ border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', padding: '18px 22px', maxHeight: 460, overflowY: 'auto', background: 'var(--sg-card)' }}>
            <div className="sg-article" style={{ fontSize: 14.5, lineHeight: 1.65, color: 'var(--sg-text)' }}
              dangerouslySetInnerHTML={{ __html: article.bodyHtml }} />
          </div>

          {/* internal link ideas */}
          {article.internalLinks && article.internalLinks.length > 0 && (
            <div>
              <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', marginBottom: 7 }}>Internal link ideas</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7 }}>
                {article.internalLinks.map((l, i) => (
                  <span key={i} style={{ fontSize: 12, color: 'var(--sg-blue-600)', background: 'var(--sg-blue-50)', padding: '4px 10px', borderRadius: 'var(--sg-radius-pill)' }}>{l}</span>
                ))}
              </div>
            </div>
          )}

          {/* image prompt */}
          {article.imagePrompt && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, fontSize: 12.5, color: 'var(--sg-text-2)', background: 'var(--sg-sunken)', borderRadius: 'var(--sg-radius-md)', padding: '10px 14px' }}>
              <Icon name="sparkles" size={15} color="var(--sg-violet-600)" />
              <span style={{ flex: 1 }}><strong style={{ color: 'var(--sg-text)' }}>Featured image:</strong> {article.imagePrompt}</span>
            </div>
          )}

          {/* actions */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', borderTop: '1px solid var(--sg-border)', paddingTop: 16 }}>
            <CopyBtn text={fullHtml} k="art-html" copied={copied} setCopied={setCopied} label="Copy HTML" />
            <CopyBtn text={article.metaDescription} k="art-meta" copied={copied} setCopied={setCopied} label="Copy meta" />
            <button onClick={() => download(article.slug + '.html', fullHtml, 'text/html')}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 32, padding: '0 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-card)', color: 'var(--sg-text-2)', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12 }}>
              <Icon name="download" size={13} /> Download
            </button>
            <span style={{ flex: 1 }} />
            <SoonBtn icon="send" label="Publish to GHL Blog" onClick={() => alert('Publishing to GHL Blog (on the client’s domain) is the next phase — it needs a GHL Private Integration Token. For now, copy or download the article.')} />
          </div>
        </div>
      </Card>
    );
  }

  function CampaignResult({ campaign, copied, setCopied }) {
    const sorted = campaign.slice().sort((a, b) => (a.day || 0) - (b.day || 0));
    const allText = sorted.map((p) => {
      const m = platMeta(p.platform);
      return '— ' + m.label + ' (Day ' + p.day + ') —\n' + p.post + '\n' + (p.hashtags || []).join(' ');
    }).join('\n\n');
    return (
      <Card>
        <CardHead title={`Social campaign (${sorted.length})`} sub="A 2-week drip promoting the article — reinforces your brand entity for AI search"
          right={<CopyBtn text={allText} k="camp-all" copied={copied} setCopied={setCopied} label="Copy all" />} />
        <div style={{ padding: '6px 16px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {sorted.map((p, i) => {
            const m = platMeta(p.platform);
            const txt = p.post + '\n' + (p.hashtags || []).join(' ');
            return (
              <div key={i} style={{ border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', padding: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 9 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: m.c, background: m.bg, padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>{m.label}</span>
                  <span style={{ fontSize: 11.5, color: 'var(--sg-text-3)' }}>Day {p.day}</span>
                  <span style={{ flex: 1 }} />
                  <CopyBtn text={txt} k={'post-' + i} copied={copied} setCopied={setCopied} />
                </div>
                <div style={{ fontSize: 13.5, lineHeight: 1.55, color: 'var(--sg-text)', whiteSpace: 'pre-wrap' }}>{p.post}</div>
                {p.hashtags && p.hashtags.length > 0 && (
                  <div style={{ marginTop: 8, fontSize: 12.5, color: 'var(--sg-blue-600)' }}>{p.hashtags.join(' ')}</div>
                )}
                {p.imagePrompt && (
                  <div style={{ marginTop: 8, fontSize: 11.5, color: 'var(--sg-text-3)' }}><Icon name="sparkles" size={11} color="var(--sg-violet-600)" /> {p.imagePrompt}</div>
                )}
              </div>
            );
          })}
          <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid var(--sg-border)', paddingTop: 14 }}>
            <SoonBtn icon="calendar" label="Schedule to GHL Social Planner" onClick={() => alert('Auto-scheduling to GHL Social Planner is the next phase — it needs a GHL Private Integration Token. For now, copy the posts into your Social Planner.')} />
          </div>
        </div>
      </Card>
    );
  }

  function Content() {
    const ent = window.SGLive.useEntitlement();
    const [approved, setApproved] = React.useState(null);
    React.useEffect(() => { window.SGLive.fetchApprovedKeywords().then(setApproved); }, []);

    const [keyword, setKeyword] = React.useState('');
    const [competitor, setCompetitor] = React.useState('');
    const [tone, setTone] = React.useState('Professional');
    const [busy, setBusy] = React.useState(false);
    const [result, setResult] = React.useState(null);
    const [err, setErr] = React.useState(null);
    const [copied, setCopied] = React.useState(null);

    const locked = ent.paidData === false && ent.status !== 'trial';

    const generate = () => {
      const kw = keyword.trim();
      if (!kw || busy) return;
      setBusy(true); setErr(null); setResult(null);
      window.SGLive.generateContent(kw, { competitor: competitor.trim() || undefined, tone }).then((r) => {
        setBusy(false);
        if (r.ok) setResult(r);
        else setErr(r.message || 'Generation failed.');
      });
    };

    return (
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
        <PageHead eyebrow="Create" title="Content Studio" icon="edit"
          sub="Turn an approved keyword into a SEO + GEO-optimized article and a ready-to-post social campaign — written by Claude." />

        {locked ? (
          <window.SGLive.PaidLock title="Content Studio unlocks on a paid plan" blurb="AI article + social-campaign generation uses premium models. Upgrade to start producing optimized content." />
        ) : (
          <Card>
            <div style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 14 }}>
              {/* keyword: approved dropdown + free text */}
              <div>
                <label style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', display: 'block', marginBottom: 7 }}>Topic / keyword</label>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  <input value={keyword} onChange={(e) => setKeyword(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') generate(); }}
                    placeholder="e.g. your main service, product or topic"
                    style={{ flex: 2, minWidth: 240, height: 44, padding: '0 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 14, color: 'var(--sg-text)', outline: 'none' }} />
                  <select value="" onChange={(e) => { if (e.target.value) setKeyword(e.target.value); }}
                    style={{ flex: 1, minWidth: 180, height: 44, padding: '0 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 13.5, fontWeight: 600, color: 'var(--sg-text-2)', cursor: 'pointer' }}>
                    <option value="">{approved && approved.length ? 'Pick an approved keyword…' : 'No approved keywords yet'}</option>
                    {(approved || []).map((k) => <option key={k} value={k}>{k}</option>)}
                  </select>
                </div>
              </div>
              {/* options */}
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <input value={competitor} onChange={(e) => setCompetitor(e.target.value)}
                  placeholder="Out-rank a competitor? (optional, e.g. competitor.com)"
                  style={{ flex: 2, minWidth: 240, height: 42, padding: '0 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 13.5, color: 'var(--sg-text)', outline: 'none' }} />
                <select value={tone} onChange={(e) => setTone(e.target.value)}
                  style={{ flex: 1, minWidth: 160, height: 42, padding: '0 12px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 13.5, fontWeight: 600, color: 'var(--sg-text-2)', cursor: 'pointer' }}>
                  {TONES.map((t) => <option key={t} value={t}>{t} tone</option>)}
                </select>
              </div>
              {/* generate */}
              <button onClick={generate} disabled={busy || !keyword.trim()}
                style={{ width: '100%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 9, height: 48, border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: (busy || !keyword.trim()) ? 'not-allowed' : 'pointer', opacity: (busy || !keyword.trim()) ? 0.55 : 1, fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 15, color: '#fff', background: 'var(--sg-grad-violet, var(--sg-grad-brand))', boxShadow: '0 4px 14px rgba(124,58,237,0.32)' }}>
                <Icon name="sparkles" size={18} /> {busy ? 'Writing your content… (~20s)' : 'Generate article + campaign'}
              </button>
              {ent.status === 'trial' && (
                <div style={{ fontSize: 12, color: 'var(--sg-text-3)' }}>Generates a full article + a 6–8 post social campaign optimized for Google and AI answer engines.</div>
              )}
            </div>
          </Card>
        )}

        {err && (
          <Card style={{ padding: 14, display: 'flex', alignItems: 'center', gap: 11, background: 'var(--sg-red-50, #FDECEC)', border: '1px solid var(--sg-red-100, #F8C9C9)' }}>
            <Icon name="alert-triangle" size={18} color="var(--sg-red, #DC2626)" />
            <div style={{ flex: 1, fontSize: 13, color: 'var(--sg-text)' }}>{err}</div>
          </Card>
        )}

        {busy && !result && (
          <Card style={{ padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
            <Icon name="sparkles" size={26} color="var(--sg-violet-600)" />
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--sg-text)' }}>Writing a SEO + GEO-optimized article and social campaign…</div>
            <div style={{ fontSize: 12.5, color: 'var(--sg-text-3)' }}>This takes about 20–30 seconds.</div>
          </Card>
        )}

        {result && (
          <React.Fragment>
            <ArticleResult article={result.article} engine={result.engine} copied={copied} setCopied={setCopied} />
            {result.campaign && result.campaign.length > 0 && <CampaignResult campaign={result.campaign} copied={copied} setCopied={setCopied} />}
          </React.Fragment>
        )}
      </div>
    );
  }

  window.SGContent = Content;
})();
